<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-20">
            Career & Lifestyle Survey Form
        </div>
        <div class="content card round-medium bg-color">
            <div class="caption caption-margins round-medium margin-bottom-20 card">
                <img v-bind:src="'images/mpower-new/career/01.png'" class="img-resize">
            </div>
            <div class="content">
                <p class="talent-description margin-bottom-20">
                    Lately my company is conducting a survey trying to understand what are the Career & lifestyles which Malaysians desire the most. 
                    </p>
                    <p class="talent-description margin-bottom-20">
                        Because according to a research done by Harvard on their graduate students, over a period of 25 years, the results indicated that for those who know what they want, 80% of them will likely to achieve their goals. 
                        On the contrary, if they don’t know what they want, most likely 80% of them will not get what they desire.
                    </p>
                    <p class="talent-description">
                        To ensure that you stand a better chance to achieve what you want and provide a better standard of living to your family or love ones, are you willing to spend just 4 minutes to answer 7 simple questions ?
                    </p>
            </div>
            <div class="content">
                <div class="talent-input">Your Name</div>
                <div class="input-wrapper" >
                    <input class="custom-input" v-model="username" id="name-input" name="name" type="text" placeholder="Your name here">
                </div>

                <div class="talent-input">Phone Number</div>
                <div class="input-wrapper" >
                    <input class="custom-input" v-model="phonenumber" id="phone-input" name="phone" type="text" placeholder="017xxxxxxxx">
                </div>
         
                <div class="talent-input">Email Address</div>
                <div class="input-wrapper">
                    <input class="custom-input" v-model="email" id="email-input" name="address" type="email" placeholder="Your email here">
                </div>
           
                <div class="talent-input">Please select your language</div>
                <div class="input-wrapper">
                    <select class="custom-selection" v-model="language" name="language" id="language-input">
                        <option value="">Language</option>
                        <option value="en">English</option>
                        <option value="bm">Bahasa Melayu</option>
                        <option value="cn">Chinese</option>
                    </select>
                </div>
          
                <div class="text-left"  id="agreement-input">
                    <input class="align-middle" v-model="agreement" name="agreement" type="checkbox" />
                    <span class="talent-agreement">I/We have read, understood and agreed to the <span id="pnc" @click="showModal()"><strong>Privacy Declaration</strong></span></span>
                </div>
            </div>
            <div class="content">
                <a @click="startTest()" class="generali-button-red">
                    Let's get started
                </a>
                <a @click="resetTest()" class="button button-m button-line round-huge bottom-0 button-center-medium">
                    reset
                </a>
            </div>
        </div>
        <modal :name="'declaration-modal'" :width="'100%'" :height="'100%'" :scrollable="true" :adaptive="true" :close-on-backdrop="false" :close-on-esc="false" :click-to-close="false"
            styles="background-color: #DADADA !important; margin-bottom: 60px !important; overflow-y: scroll;
            max-width: 1000px; margin: 0 auto;">
            <div class="button-close-position">
                <button class="button-close" id="close_model"
                    @click="$modal.hide('declaration-modal')">
                    X
                </button>
            </div>
            <div class="declaration-wrapper">
                <div class="declaration-title mb-30">Privacy Declaration</div>
                <div class="declaration-description">
                    “I/We am/are aware that i/we am/are not obliged to provide all the information requested. By filling in this form, I/we agree to GML Life Insurance Berhad, its agent and/or constractors to collect, hold, use, delete,disclose, transfer, and process in any other way, all my/our personal data provided in this form, for purposes of research, statistics,survey and communicating with me/us in respect of GML Life Insurance Berhad’s products. I/We have the right to see my/our personal data that GML LIfe Insurance Berhad holds, and make any corrections if they are wrong.If I/we want to do this, or if I/we have any other queries or complaints in respect of my/our personal data, I/we will contact GML Life Insurance’s Berhad’s Customer Service Officer by telephone at 1300881616 or by email at customer.care@axa-life.com.my. I/We can subsequently withdraw this consent at any time by duly notifying GML Life Insurance Berhad in writing.
                </div>
            </div>
            <div style="margin-bottom: 80px"></div>
        </modal>
    </div>
</template>
<style scoped>

.button:active{
    box-shadow: none !important;
}

.content{
    margin-bottom: 20px !important;
}

.mb-30 {
    margin-bottom: 30px !important;
}

.bg-color{
    background-color: rgb(255, 255, 255,0.7)
}

body.modal-open {
    overflow: hidden;
}
.button-close-position{
    position: absolute;
    z-index: 1;
    top: 5px;
    right: 5px;
}
.button-close {
    background-color: #c1210c;
    height: 22px;
    width: 22px;
    border-radius: 16px;
    cursor: pointer;
    font-weight: bold;
    color: #ffffff;
}
.declaration-wrapper {
    padding: 30% 5%;
}
.declaration-title {
    font-size: 18px;
    color: #7A7B7A;
}
.declaration-description {
    font-size: 12px;
    color: #7A7B7A;
    line-height: normal;
    text-align:justify;
    word-spacing: -2px;
}
.talent-input {
    font-size: 10px;
    color: #6c6c6c;
    text-align: left;
}
.talent-description{
    font-size: 12px;
    color: #6c6c6c;
    line-height: normal;
    text-align: justify;
}
.talent-agreement {
    font-size: 9px;
    color: #6c6c6c;
    line-height: normal;
    vertical-align: middle;
    margin-left: 3px;
}
.input-wrapper {
    width: 100%;
}
.custom-input {
    padding: 0 10px 0 10px;
    font-size: 14px;
    height: 30px;
    width: 100%;
    background: #FFE1E1;
    /* color: rgb(255,255,255,0.7); */
    color: #6c6c6c;
    margin-bottom: 10px;
}
.custom-selection {
    padding: 0 10px 0 10px;
    border-left: 3px solid #AC1F08;
    font-size: 14px;
    height: 30px;
    width: 100%;
    background: #FFE1E1;
    /* color: rgb(255,255,255,0.7); */
    color: #6c6c6c;
    -webkit-appearance: none;
}
.img-resize {
    max-width: 100%;
    margin: 0 auto;
}
#pnc{
    cursor: pointer;
}
@media(min-width:768px){
    .talent-description,.talent-input{
        font-size: 13px;
    }
    .talent-agreement{
        font-size: 11px;
    }
}
</style>
<script>
  import $ from 'jquery'
export default {
    name: "Talent",
    computed: {
    },
    data(){
        return {
            username: '',
            phonenumber: '',
            email: '',
            language: '',
            agreement: '',
            conclusion: {
                'name': '',
                'phone': '',
                'email': '',
                'language': '',
            },
        }
    },
    methods: {
        showModal(){
            this.$modal.show('declaration-modal')
        },
        hideModal(){
            this.$modal.hide('declaration-modal');
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        startTest(){
            if(this.username==''){
                document.querySelector("#name-input").style.border = "1px solid red";
            }
            else{
                document.querySelector("#name-input").style.border = "unset";
            }
            if(this.phonenumber==''){
                document.querySelector("#phone-input").style.border = "1px solid red";
            }
            else{
                document.querySelector("#phone-input").style.border = "unset";
            }
            if(this.email==''){
                document.querySelector("#email-input").style.border = "1px solid red";
            }
            else{
                document.querySelector("#email-input").style.border = "unset";
            }
            if(this.language==''){
                document.querySelector("#language-input").style.border = "1px solid red";
            }
            else{
                document.querySelector("#language-input").style.border = "unset";
                document.querySelector("#language-input").style.borderLeft = "1px solid red";
            }
            if(this.agreement==''){
                document.querySelector("#agreement-input").style.border = "1px solid red";
            }
            else{
                document.querySelector("#agreement-input").style.border = "unset";
            }

            if(this.username!=''&&this.phonenumber!=''&&this.email!=''&&this.language!=''&&this.agreement){
                // named route
                const phone_format = /^([0]{1})([0-9]{2})[-]?([0-9]{3,4})[-]?([0-9]{4})$/;
                if (!this.validEmail(this.email)) {
                    document.querySelector("#email-input").style.border = "1px solid red";
                    return
                }
                if(!this.phonenumber.match(phone_format)){
                    document.querySelector("#phone-input").style.border = "1px solid red";
                    return
                }
                this.conclusion.name = this.username
                this.conclusion.phone = this.phonenumber
                this.conclusion.email = this.email
                this.conclusion.language = this.language
                localStorage.setItem('career_test',JSON.stringify(this.conclusion))
                window.scrollTo(0,0);
                this.$router.push({path: 'career-disturb'})
            }
        },
        resetTest(){
                this.username = ''
                this.phonenumber = ''
                this.email = ''
                this.language = ''
                localStorage.setItem('career_test',JSON.stringify(this.conclusion))
                document.querySelector("#name-input").value = "";
                document.querySelector("#name-input").style.removeProperty("border");
                document.querySelector("#phone-input").value = "";
                document.querySelector("#phone-input").style.removeProperty("border");
                document.querySelector("#email-input").value = "";
                document.querySelector("#email-input").style.removeProperty("border");
                document.querySelector("#language-input").value = "";
                document.querySelector("#language-input").style.removeProperty("border");
                document.querySelector("#agreement-input").style.removeProperty("border");
        }
    },
    mounted: function(){
        $('#pnc').on('click',function(){
            $('.header').css('z-index','1');
        });
        $(document).on('click','#close_model',function(){
            $('.header').css('z-index','96');
        });
        window.scrollTo(0,0);
    }
}
</script>